import { Injectable, inject } from '@angular/core';
import {
	ActivatedRouteSnapshot,
	CanActivate,
	CanActivateChild,
	CanMatch,
	Route,
	Router,
	RouterStateSnapshot,
	UrlSegment,
	UrlTree
} from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../auth.service';

@Injectable({
	providedIn: 'root'
})
export class AuthGuard implements CanActivate, CanActivateChild, CanMatch {
	private authService = inject(AuthService);
	private router = inject(Router);

	public canActivate(
		_next: ActivatedRouteSnapshot,
		state: RouterStateSnapshot
	): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
		return this.checkLogin(state.url);
	}

	public canActivateChild(
		next: ActivatedRouteSnapshot,
		state: RouterStateSnapshot
	): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
		return this.canActivate(next, state);
	}

	public canMatch(_route: Route, segments: UrlSegment[]): Observable<boolean> | Promise<boolean> | boolean {
		return this.checkLogin(segments.join('/'));
	}

	private checkLogin(origin: string): boolean {
		// not logged in => login
		if (!this.authService.isLoggedIn()) {
			this.authService.login(origin);
			// Navigate to login processing page, to show loading spinner instead of "not found" error page
			this.router.navigateByUrl('/login', { replaceUrl: true });
			return false;
		}

		// logged in => access
		return true;
	}
}
